<template>
    <form id="changePassForm" method="post" action="/ajax_new/Forms/changePass/" @submit.prevent="submit">
        <div v-if="!message">
            <div class="form-group form-group_personal row" :class="{ 'form-group--error': $v.password.$error }">
                <label for="changePassForm_password" class="col-md-2 col-form-label">Новый пароль</label>
                <div class="col-md-5">
                  <div class="input-group">
                    <input  :type="showInput ? 'text' : 'password'"  name="PASSWORD" v-model.trim="password"
                           @input="setPassword($event.target.value)"
                           @blur="$v.password.$touch()"
                           id="changePassForm_password" class="form-control">
                    <div @click="setText()"  class="input-group-addon">
                      <i  v-if="!showInput" class="fa fas fa-eye"></i>
                      <i   v-if="showInput" class="fa fas fa-eye-slash"></i>

                    </div>

                    <div class="invalid-input" v-if="!$v.password.required">
                        Поле обязательно для заполнения
                    </div>
                    <div class="invalid-input" v-if="!$v.password.minLength">
                        Минимальная длина пароля {{ $v.password.$params.minLength.min }}
                    </div>



                    </div>
                </div>
            </div>
            <div class="form-group form-group_personal row" :class="{ 'form-group--error': $v.confirmPassword.$error }">
                <label for="changePassForm_passwordConfirm" class="col-md-2 col-form-label">
                    Подтверждение пароля
                </label>
                <div class="col-md-5">
                  <div class="input-group">

                    <input  :type="showInput ? 'text' : 'password'"  name="PASSWORD_CONFIRM" v-model.trim="confirmPassword"
                           @input="setConfirmPassword($event.target.value)"
                           @blur="$v.confirmPassword.$touch()"
                           id="changePassForm_passwordConfirm" class="form-control" >
                  <div @click="setText()"  class="input-group-addon">
                    <i  v-if="!showInput" class="fa fas fa-eye"></i>
                    <i   v-if="showInput" class="fa fas fa-eye-slash"></i>

                  </div>
                    <div class="invalid-input" v-if="!$v.confirmPassword.sameAsPassword">
                        Пароли не совпадают
                    </div>
                  </div>

                </div>
            </div>
            <div class="form-group form-group_personal row">
                <div class="col-md-5 push-md-2">
                    <button type="submit" class="btn btn-block btn-primary">Изменить пароль</button>
                </div>
            </div>
            <div class="alert alert-dismissable fade show alert-danger" role="alert" v-if="errors.length">
                {{ errors[0].message }}
            </div>
        </div>
        <div v-if="message">
            <h4 class="py-3">
                {{ message }}
            </h4>
        </div>
    </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, sameAs, minLength} from 'vuelidate/lib/validators'

  export default {
    name: 'change-pass',
    mixins: [validationMixin],
    data: function () {
      return {
        showInput: false,
        password: '',
        confirmPassword: '',
        message: '',
        errors: []
      }
    },
    validations: {
      password: {
        required,
        minLength: minLength(6)
      },
      confirmPassword: {
        sameAsPassword: sameAs('password')
      }
    },
    methods: {
      setText(){
        this.showInput = !this.showInput;
      },
      setPassword (val) {
        this.password = val
        this.$v.password.$reset()
      },
      setConfirmPassword (val) {
        this.confirmPassword = val
        this.$v.confirmPassword.$reset()
      },
      submit: async function (e) {
        this.errors = []
        this.message = ''
        this.$v.$touch()

        let targetNode = e.target
        let action = targetNode.action

        if (!this.$v.$invalid) {
          let formData = new FormData(targetNode)

          await this.$recaptchaLoaded()
          const token = await this.$recaptcha('changePass')

          formData.append('g-recaptcha-response', token)

          this.$http.post(action, formData).then(request => {
            if (request.data.status) {
              this.message = request.data.data.message
            } else {
              this.errors = request.data.errors
            }
          }).catch(error => {
            console.error(error)
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/forms/ChangePass.vue